import type { BrandManagerInfoInput } from '@@partner:graphql/mutation/employees/saveBrandManager.gql'
import type { BrandManager } from '@@partner:types:app'
import type { GQL_ID } from '@@partner:types:graphql'

export interface BrandManagerFormState {
  id?: GQL_ID
  firstName: string
  lastName: string
  phone: string
  status: number
  email: string

  changePassword: boolean
  password: string
  repeatPassword: string
}

export const PROMOCODE_DEFAULT_STATE: BrandManagerFormState = {
  id: undefined,
  firstName: '',
  lastName: '',
  phone: '',
  status: 0,
  email: '',
  changePassword: false,
  password: '',
  repeatPassword: ''
}

export const makeBrandManagerFormState = (
  brandManager?: BrandManager
): BrandManagerFormState => {
  return mapApiDataToState(brandManager ?? ({} as BrandManager))
}

// state and api variable are same excluding info fields
// so drop them and go
export const mapStateToApiVariable = (
  state: BrandManagerFormState
): BrandManagerInfoInput => ({
  id: state.id,
  first_name: state.firstName,
  last_name: state.lastName,
  phone: state.phone,
  email: state.email,
  status: Number(state.status) ?? 0,
  password: state.changePassword || !state.id ? state.password : undefined
})

export const mapApiDataToState = (
  data: BrandManager
): BrandManagerFormState => ({
  id: data.id,
  firstName: data.first_name,
  lastName: data.last_name,
  phone: data.phone,
  status: data.status,
  email: data.email,
  password: '',
  repeatPassword: '',
  changePassword: false
})
